import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import emptyState from 'assets/icons/empty-state.svg';
import useMobile from 'hooks/useMobile';
import { NoConversationsWrapper } from './style';
import { NoConversationsProps } from './types';

const NoConversations = ({ title = 'noChatsFound', description = 'noChatsFoundMessage' }: NoConversationsProps) => {
  const { t } = useTranslation();
  const { isMobileView } = useMobile();

  return (
    <NoConversationsWrapper>
      {isMobileView && <img src={emptyState} alt={t('noChatsFoundAlt')} />}
      <Stack gap={1} alignItems="center">
        <Typography variant="h3">{t(title)}</Typography>
        <Typography variant="body1">{t(description)}</Typography>
      </Stack>
    </NoConversationsWrapper>
  );
};

export default NoConversations;
